export default __webpack_public_path__ + "static/media/truck.fcc3f35e.svg";